module.exports = __webpack_public_path__ + "img/helpcenter_bg_v1.f47121d.svg";